import React from "react";

const UserBuyer = ({ userbuyer }) => {
  const HandlerData = KEY => {
    switch (KEY) {
      case "fullname":
        return {
          name: "نام و نام خانوادگی",
          value: userbuyer[KEY] != null ? userbuyer[KEY] : "ثبت نشده است",
        };
      case "gender":
        return {
          name: "جنسیت",
          value:
            userbuyer[KEY] != null
              ? userbuyer[KEY] == "men"
                ? "اقا"
                : "بانو"
              : "ثبت نشده است",
        };
      case "mobile":
        return {
          name: "شماره همراه",
          value: userbuyer[KEY] ? userbuyer[KEY] : "ثبت نشده است",
        };
      case "national_code":
        return {
          name: "کدملی",
          value: userbuyer[KEY] ? userbuyer[KEY] : "ثبت نشده است",
        };
    }
  };
  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        <h4 style={{ fontSize: "18px" }}>مشخصات پرداخت کننده</h4>
      </div>
      <div className="row justify-content-between px-2">
        {Object.keys(userbuyer).map(function (value, key) {
          if (HandlerData(value))
            return (
              <div
                key={key}
                className="col-md-6 d-flex justify-content-start align-items-center"
              >
                <div>
                  <span style={{ fontWeight: "500" }}>
                    {HandlerData(value)["name"]} :
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "400", marginRight: "5px" }}>
                    {HandlerData(value)["value"]}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default UserBuyer;
